export default "__VITE_PUBLIC_ASSET__ec3e7c9c__"